import TableList from "@components/templates/tablelist";
import { HttpGetCalculationReleaseList, HttpEditCalculationRelease,HttpPriceAdjustment,HttpGetStatusNum } from "@/service/products/calculationRelease";
import { mapState, mapGetters } from "vuex";
import compImport from '../compimport'
import comIndex from './update'
import mixin from "./mixin";
export default {
    mixins: [TableList, mixin],
    components: {
        comIndex,
        compImport
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: { show: true },
            spanTabs: { show: true },
            formData:{
                search: {
                    EQ_status:null,
                    IN_status:null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            datename:'',
            datetime:'',
            Plugins: {show: true},
            initData: '',
        };
    },
    methods: { 
        ajaxRequest: HttpGetCalculationReleaseList,
        spanAjaxRequest:HttpGetStatusNum,
        interceptRequest: (params) => {
            if (params.search.EQ_status == null) {
                params.search.IN_status = null
            } else if(params.search.EQ_status == 0){
                params.search.IN_status = 0
            } else if(params.search.EQ_status == 1){
                params.search.IN_status = [2,3,5]
            }
            delete params.search.EQ_status;

            const {CN_asin } = params.search;
            let IN_asin;
            if(CN_asin){
                IN_asin = CN_asin.replace(/\n/g,",");
            }
            params.search.IN_asin = IN_asin;
            delete params.search.CN_asin;

            return params;
        },
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'calculationReleaseUpdate',
                        params: { type: "add"},
                        query: { id:null }
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'calculationReleaseUpdate',
                        params: { type: "edit"},
                        query: { id: params },
                    });
                    break;
                 case "improve":
                    this.$router.push({
                        name: 'calculationReleaseUpdate',
                        params: { type: "improve"},
                        query: { id: params },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case 'confirmQuotation':
                    this.operate = {
                        show: true,
                        alert: 'success',
                        params: {
                            id: params,
                            status: 3,
                            isInformation: 0
                        },
                        title: "确认报价",
                        desc:"确认报价吗？",
                        ajaxRequest: HttpEditCalculationRelease
                    }
                    break
                case "refuseQuotation":
                    this.operate = {
                        show: true,
                        showDesc: false,
                        alert: "error",
                        title: "拒绝报价",
                        width: 460,
                        params:{id:params,status:1,isInformation:0},
                        formdata:[
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: "拒绝原因:",
                            }
                        ],
                        ajaxRequest:HttpEditCalculationRelease
                    };
                    break;
                case "information":
                    this.operate = {
                        show: true,
                        showDesc: false,
                        alert: "success",
                        title: "补充信息",
                        width: 460,
                        params:{id:params,status:4,isInformation:1},
                        formdata:[
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: "产品信息:",
                            }
                        ],
                        ajaxRequest:HttpEditCalculationRelease
                    };
                    break;
                case "priceAdjustment":
                    this.operate = {
                        show: true,
                        alert: "success",
                        title: "调价",
                        width: 460,
                        params:{id:params,status:1,adjustStatus:1},
                        formdata: [
                            {
                                tag: "vInputNumber",
                                key: "expectVcPrice",
                                span: 24,
                                label: "期望VC售价:",
                                required: false,
                            },
                            {
                                tag: "vInputNumber",
                                key: "expectPurchasePrice",
                                span: 24,
                                label: "期望VC采购价:",
                                required: false,
                            },
                        ],
                        desc: "提示：调升的成功率较低！",
                        ajaxRequest: (data) => {
                            // 提交前处理数据
                            if (data.expectVcPrice === undefined && data.expectPurchasePrice === undefined) {
                                return Promise.reject(new Error("售价和采购价必须要填写一个！"));
                            }
                            return HttpPriceAdjustment(data);
                        }
                    };
                    break;
                    case "priceAdjustmentCalculation":
                    this.operate = {
                        title: '调价测算',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids:params,
                        querytype: 'priceA',
                        showFooter: false,
                    }
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: "批量导入",
                        showFooter: false,
                        width:460,
                        data: {
                            contextId: global.SYSID,
                        },
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/calculationReleaseProduct/importDataByCalculation",
                        name: "excelFile",
                        download:()=>{
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS +'/api/v2/calculationReleaseProduct/importTemplateByCalculation',{},'download')
                        },
                        component: "compUpload",
                    };
                    break;
                // case 'export':
                //     if(this.total>2000){
                //         this.$VMessage.error('导出数据不能大于2000');
                //     }else{
                //         this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/promotionResource/exportByFilter',this.formData,{
                //             executor:'request',
                //             download:true,
                //         }).catch(err=>{
                //             this.$VMessage.error({
                //                 content: err.message,
                //                 duration: 30,
                //                 closable: true
                //             });
                //         });
                //     }
                //     break;
            }
        },
        getOperateNodeMap(row){
            const { id,status,exceptionType,adjustStatus } = row
            return [{
                label:'查看',
                show:true,
                params:id,
                operate:'query'
            },{
                label:'编辑',
                show: status == 0,
                params:id,
                operate:'edit'
            },{
                label: "确认报价",
                show: status == 2 && adjustStatus == 0,
                params: id,
                operate: "confirmQuotation",
            },{
                label: "拒绝报价",
                show: status == 2 && adjustStatus == 0,
                params: id,
                operate: "refuseQuotation",
            },{
                label: "上架",
                show: status == 3,
                params: id,
                operate: "improve",
            },{
                label: "补充信息",
                show: status == 5 && exceptionType==0,
                params: id,
                operate: "information",
            },{
                label: "调价",
                show: (status == 4 && adjustStatus == 0)
                    || (status == 6 && adjustStatus == 0)
                    || (status == 5 && exceptionType == 1 && adjustStatus == 0),
                params: id,
                operate: "priceAdjustment",
            },{
                label: "调价测算",
                show: adjustStatus == 2,
                params: id,
                operate: "priceAdjustmentCalculation",
            }]
        },
    },
    computed: {
        TabsData(){
            return [
                {
                    name: "全部",
                    key:'EQ_status',
                    val: null
                }, {
                    name: "草稿",
                    key:'EQ_status',
                    val: 0,
                    spanKey: 'draft',
                }, {
                    name: "待处理",
                    key:'EQ_status',
                    val: 1,
                    spanKey: 'pending',
                },
            ]
        },
        ToolsData(){
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "批量导入",
                    operate: "import",
                    theme: "warning",
                },
                // {
                //     name: "导入",
                //     operate: "import",
                //     theme: "warning",
                // },
                // {
                //     name: "查询条件导出",
                //     operate: "export",
                //     theme: "primary",
                // },
            ]
        },
        SearchsData() {
            return  [
                {
                    label: "产品名",
                    tag: 'vInput',
                    key: 'EQ_productName',
                    show:true,
                },
                {
                    label: "型号",
                    tag: 'vInput',
                    key: 'EQ_productCode',
                    show:true,
                },

                // 隐藏起来的搜索
                {
                    label: "ASIN",
                    tag: 'vTextarea',
                    key: 'CN_asin',
                    style: "width:200px",
                    props:{
                        placeholder:"支持输入多个，一行一个ASIN",
                    },
                },
                {
                    label: "更新者",
                    tag: 'vInput',
                    key: 'CN_updatedName',
                    hidden:!(this.formData.search['all']==null),
                },
                {
                    label: '更新时间',
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    style: "width:180px",
                    hidden:!(this.formData.search['all']==null),
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                },
            ]
        },
        columns() {
            return  [
                {
                    show:false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },{
                    title: '操作',
                    width: 70,
                    render:this.getOperateNodes,
                },
                {
                    title: this.$t('global.common.base_information', { defaultValue: '基本信息' }),
                    render: (h, { row }) => {
                        return <div class="icon-main-container">
                            <div>
                                <div>
                                    <span class="font-bold">ASIN: </span>
                                    <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.asin}</a>
                                    <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><Icon
                                        class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                                </div>
                                <div><span class="font-bold">产品名: </span>{row.productName || '--'}</div>
                                <div><span class="font-bold">型号: </span>{row.productCode || '--'}</div>
                            </div>
                        </div>
                    },
                },
                {
                    title: '测算信息',
                    render: (h, { row }) => {                        
                        if (row.adjustVcPrice != undefined && row.adjustVcPrice != 0 && row.adjustPurchasePrice != undefined && row.adjustPurchasePrice != 0) {
                            return <div class="icon-main-container">
                                <div>
                                <div><span class="font-bold">FOB: </span>{row.fob || '--'}</div>
                                <div><span class="font-bold">DDP: </span>{row.ddp || '--'}</div>
                                <div><span class="font-bold">期望VC售价: </span>{row.expectVcPrice || '--'}<span style="color: red;font-weight: bold;"> ( {row.adjustVcPrice} ) </span></div>
                                <div><span class="font-bold">期望VC采购价: </span>{row.expectPurchasePrice || '--'}<span style="color: red;font-weight: bold;"> ( {row.adjustPurchasePrice} ) </span></div>
                                <div><span class="font-bold">Amazon日常售价: </span>{row.amazonPrice || '--'}</div>
                                <div><span class="font-bold">实际关税税负率: </span>{row.negativeTariffRate || '--'}</div>
                                <div><span class="font-bold">预估头程物流费: </span>{row.firstShippingFee|| '--'}</div>
                                <div><span class="font-bold">预估尾程物流费: </span>{row.finalShippingFee|| '--'}</div>
                                <div><span class="font-bold">SC广告花费占比: </span>{row.scAdvertisingExpenditure || '--'}</div>
                                <div><span class="font-bold">退货率: </span>{row.returnRate|| '--'}</div>
                            </div>
                        </div> 
                        } else if(row.adjustVcPrice != undefined && row.adjustVcPrice != 0) {
                            return <div class="icon-main-container">
                            <div>
                                <div><span class="font-bold">FOB: </span>{row.fob || '--'}</div>
                                <div><span class="font-bold">DDP: </span>{row.ddp || '--'}</div>
                                <div><span class="font-bold">期望VC售价: </span>{row.expectVcPrice || '--'}<span style="color: red;font-weight: bold;"> ( {row.adjustVcPrice} ) </span></div>
                                <div><span class="font-bold">期望VC采购价: </span>{row.expectPurchasePrice || '--'}</div>
                                <div><span class="font-bold">Amazon日常售价: </span>{row.amazonPrice || '--'}</div>
                                <div><span class="font-bold">实际关税税负率: </span>{row.negativeTariffRate || '--'}</div>
                                <div><span class="font-bold">预估头程物流费: </span>{row.firstShippingFee|| '--'}</div>
                                <div><span class="font-bold">预估尾程物流费: </span>{row.finalShippingFee|| '--'}</div>
                                <div><span class="font-bold">SC广告花费占比: </span>{row.scAdvertisingExpenditure || '--'}</div>
                                <div><span class="font-bold">退货率: </span>{row.returnRate|| '--'}</div>
                            </div>
                        </div>  
                        }else if(row.adjustPurchasePrice != undefined && row.adjustPurchasePrice != 0) {
                            return <div class="icon-main-container">
                                <div>
                                    <div><span class="font-bold">FOB: </span>{row.fob || '--'}</div>
                                    <div><span class="font-bold">DDP: </span>{row.ddp || '--'}</div>
                                    <div><span class="font-bold">期望VC售价: </span>{row.expectVcPrice || '--'}</div>
                                    <div><span class="font-bold">期望VC采购价: </span>{row.expectPurchasePrice || '--'}<span style="color: red;font-weight: bold;"> ( {row.adjustPurchasePrice} ) </span></div>
                                    <div><span class="font-bold">Amazon日常售价: </span>{row.amazonPrice || '--'}</div>
                                    <div><span class="font-bold">实际关税税负率: </span>{row.negativeTariffRate || '--'}</div>
                                    <div><span class="font-bold">预估头程物流费: </span>{row.firstShippingFee|| '--'}</div>
                                    <div><span class="font-bold">预估尾程物流费: </span>{row.finalShippingFee|| '--'}</div>
                                    <div><span class="font-bold">SC广告花费占比: </span>{row.scAdvertisingExpenditure || '--'}</div>
                                    <div><span class="font-bold">退货率: </span>{row.returnRate|| '--'}</div>
                                </div>
                            </div>  
                        } else {
                            return <div class="icon-main-container">
                                <div>
                                    <div><span class="font-bold">FOB: </span>{row.fob || '--'}</div>
                                    <div><span class="font-bold">DDP: </span>{row.ddp || '--'}</div>
                                    <div><span class="font-bold">期望VC售价: </span>{row.expectVcPrice || '--'}</div>
                                    <div><span class="font-bold">期望VC采购价: </span>{row.expectPurchasePrice || '--'}</div>
                                    <div><span class="font-bold">Amazon日常售价: </span>{row.amazonPrice || '--'}</div>
                                    <div><span class="font-bold">实际关税税负率: </span>{row.negativeTariffRate || '--'}</div>
                                    <div><span class="font-bold">预估头程物流费: </span>{row.firstShippingFee|| '--'}</div>
                                    <div><span class="font-bold">预估尾程物流费: </span>{row.finalShippingFee|| '--'}</div>
                                    <div><span class="font-bold">SC广告花费占比: </span>{row.scAdvertisingExpenditure || '--'}</div>
                                    <div><span class="font-bold">退货率: </span>{row.returnRate|| '--'}</div>
                                </div>
                            </div>
                        }
                    },
                },
                {
                    title: '测算结果',
                    render: (h, { row }) => {
                        return <div class="icon-main-container">
                            <div>
                                <div><span class="font-bold">店铺: </span>{row.channelFlag || '--'}</div>
                                <div><span class="font-bold">销售价: </span>{row.sellingPrice || '--'}</div>
                                <div><span class="font-bold">供货价: </span>{row.supplyPrice|| '--'}</div>
                                <div><span class="font-bold">广告投入: </span>{row.advertisingInvestment|| '--'}</div>
                                <div><span class="font-bold">最终回款: </span>{row.paymentCollection|| '--'}</div>
                                <div><span class="font-bold">运费预估: </span>{row.freightEstimation|| '--'}</div>
                                <div><span class="font-bold">amazon利润占比: </span>{row.amazonProfit || '--'}</div>
                                <div><span class="font-bold">客户利润占比: </span>{row.customerProfit || '--'}</div>
                                <div><span class="font-bold">Term: </span>{row.term|| '--'}</div>
                            </div>
                        </div>
                    },
                },
                {
                    title: '状态',
                    key: 'status',
                    width:150,
                    render: (h, { row }) => {
                        const status = row.status;
                        // 更安全的查找和默认值处理
                        const foundItem = this.statusList.find(item => item.value == status);
                        return (
                            <vButton
                                ghost
                                theme={foundItem.theme}
                                size="small"
                                class={{ 
                                    'cursor-not-allowed': true, // 修正类名
                                    'width-70': true 
                                }}
                            >
                                {foundItem.label}
                            </vButton>
                        );
                    }
                },
                {
                    title: '调价状态',
                    key: 'adjustStatus',
                    width:150,
                    render: (h, { row }) => {
                        const adjustStatus = row.adjustStatus;
                        if (adjustStatus != 0) {
                            // 更安全的查找和默认值处理
                            const foundItem = this.adjustStatusList.find(item => item.value == adjustStatus);
                            return (
                                <vButton
                                    ghost
                                    theme={foundItem.theme}
                                    size="small"
                                    class={{
                                        'cursor-not-allowed': true, // 修正类名
                                        'width-80': true
                                    }}
                                >
                                    {foundItem.label}
                                </vButton>
                            );
                        } else {
                            return<div>无</div>
                        }
                    }
                },
                {
                    title: '更新者',
                    width:150,
                    render: (h, { row }) => {
                        return <div>
                        <div><span>{row.updatedName || '--'}</span></div>
                        </div>
                    },
                },
                {
                    title: '更新时间',
                    width:150,
                    render: (h, { row }) => {
                        return <div>
                        <div><span>{row.updatedAt || '--'}</span></div>
                        </div>
                    },
                },
            ];
        },

    },

};
